import styled, { createGlobalStyle } from "styled-components"
import { colors, flexDisplayCenter } from "./base"

createGlobalStyle`
  @font-face {
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap');
  font-family: Nunito Sans,sans-serif;
  }

  body {
    background: black;
    margin-top: 100px;
  }
`

export const SideBarContainer = styled.header`
  ${flexDisplayCenter()};
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  flex: 1;

  background-color: ${colors.sideNavBackground};
  left: 0;
  bottom: 0;
  top: 0;
  //border-top: 3px solid ${colors.sideNavTopBorder};
  overflow: auto;

  @media only screen and (max-width: 950px) {
    min-height: 70vh;
    min-width: 100vw;
  }
`

export const ProfilePicture = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 0px;
  min-width: 0px;
`

export const NavContainer = styled.nav`
  display: flex;
  > ul {
    list-style-type: none;
    margin: 0px;
  }

  @media only screen and (max-width: 950px) {
    justify-content: center;
  }
`

export const NavItem = styled.li`
  padding: 5px;
  font-size: 20px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  position: relative;
  letter-spacing: 1px;
  color: ${colors.sideNavLink};
  transition: transform 0.25s ease-in-out;
  margin-bottom: 15px;


  :hover {
    cursor: pointer;
    // transform: rotate(45deg);
    transform: scale(1.04, 1.04);
    color: ${colors.homeBackground};
    text-decoration: none;
  }

  > a {
    color:  ${props =>
      props.active ? colors.sideNavLinkActive : colors.sideNavLink};
    font-weight: lighter;
    border-radius: 6px;
    padding: 5px;
    border: #ffffffa1 1px solid;
    background: ${props =>
      props.active ? colors.pageHeader : colors.sideNavBackground};
    :hover {
      color: ${colors.textColorDark};
      text-decoration: none;
      background: ${colors.pageHeader};
    }
`

export const ImageWrapper = styled.div`
  transition: transform 2s ease-in-out;
  position: relative;

  img {
    border: ${colors.pageHeader} 1px solid;
    padding: 3px;
    user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-drag: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }

  :active {
    transform: rotate(1080deg) scale(1.05);
  }
`

export const SocialContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 16px;
  display: flex;
  justify-content: center;

  span {
    margin-right: 18px;
    font-size: 24px;
    background: ${colors.headerBorder};
    padding: 2px 3px 1px 4px;
    border-radius: 4px;
    border: #ffffffa1 1px solid;
    transition: transform 0.25s ease-in-out;
    transform: scale(1, 1);
    display: flex;
    height: 35px;
    width: 35px;
    align-items: center;
    justify-content: center;

    :hover {
      cursor: pointer;
      transform: scale(1.1, 1.1);
    }
  }
`
